import { useEffect, useState } from "react";
import { useGetSharedContentInfo } from "../../../queries/auth";
import { VStack } from "../../../shared/utils";
import { useAuthStore } from "../../../store/useAuthStore";
import SharedWithMeAgTable from "./SharedAgTable";
import { SharedPreviewCards } from "./SharedPreviewCards";
import Loader from "../../../shared/Loader";

export function SharedPagesCard() {
  const { accessToken } = useAuthStore();
  const { isPlaceholderData, data } = useGetSharedContentInfo(
    accessToken || "",
    accessToken !== undefined && accessToken !== ""
  );

  const [sharedData, setSharedData] = useState<any>();

  useEffect(() => {
    if (data) {
      setSharedData(data);
    }
  }, [data])

  return (
    <>
      <div
        className={`px-4 sm:px-6 flex-1 lg:p-8 bg-white pt-6 border border-borderColor shadow-box rounded-xl h-[850px] ${
          isPlaceholderData ? "loading" : "min-h-full"
        }`}
      >
        <p className="text-lg font-semibold pb-4">All Shared With Me</p>
        {((sharedData && sharedData?.length === 0) ||
          sharedData?.data?.length === 0) && (
          <div className="flex items-center justify-center h-[500px]">
            <VStack className="items-center justify-center text-center">
              <img
                className="h-45 w-45 mx-auto"
                src="/media/icons/emptyFolder.svg"
                alt="empty folder"
              />
              <p className="text-sm pt-4">You have no files shared with you</p>
            </VStack>
          </div>
        )}
        
        {sharedData && sharedData?.data?.length > 0 && (
          <>
          <SharedPreviewCards data={(sharedData?.data?.filter((obj: any) => obj.isLive === true) as any[]) || []} />
          <SharedWithMeAgTable data={(sharedData?.data?.filter((obj: any) => obj.isLive === true) as any[]) || []} />
          </>
        )}
      </div>
    </>
  );
}
